const App = () => {
    return (
        <>
            <p>Alerts</p>
        </>
    );
};

export default App;
